import { ReactElement } from 'react';

import BusinessInformation from 'src/pages/AddMerchantPage/steps/BusinessInformation';
import MerchantInformation from 'src/pages/AddMerchantPage/steps/MerchantInformation';
import { SelectPartner } from 'src/pages/AddMerchantPage/steps/SelectPartner';
import { ServiceRequirements } from 'src/pages/AddMerchantPage/steps/ServiceRequirements';
import SummaryInformation from 'src/pages/AddMerchantPage/steps/SummaryInformation';
import { SupportingDocuments } from 'src/pages/AddMerchantPage/steps/SupportingDocuments';

export type Step = {
    label: string;
    completed: boolean;
    accessor: string;
    form: ReactElement;
};

// the add merchant steps, completed status and form components
export const ADD_MERCHANT_STEPS: Step[] = [
    {
        label: 'Select Partner',
        accessor: 'partnerId',
        completed: false,
        form: <SelectPartner key="select-partner" />,
    },
    {
        label: 'Service Requirements',
        accessor: 'serviceRequirements',
        completed: false,
        form: <ServiceRequirements key="service-requirements" />,
    },
    {
        label: 'Merchant Information',
        accessor: 'merchantInformation',
        completed: false,
        form: <MerchantInformation key="merchant-information" />,
    },

    {
        label: 'Business Information',
        accessor: 'businessInformation',
        completed: false,
        form: (
            <BusinessInformation
                key="business-information"
                taCode="A2A2A2" // TODO: Upate this with the TA Code from the previous § when backend is ready
            />
        ),
    },
    {
        label: 'Supporting Documents',
        accessor: 'supportingDocuments',
        completed: false,
        form: <SupportingDocuments key="supporting-documents" />,
    },
    {
        label: 'Summary',
        accessor: 'summary',
        completed: false,
        form: <SummaryInformation key="summary-information" />,
    },
];

export enum InvoiceTo {
    PARTNER = 'PARTNER',
    MERCHANT = 'MERCHANT',
}
